import {
  collection,
  getDocs,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../../../firebase";
import { rangeWithOffset, rangeFromIsoStrings } from "../dates/range";
import { OriginsCompanys } from "../../../../utils/objects/OriginsCompanys";
import { cancellationStatesFalabbelaSelector } from "../../../../utils/objects/translateStates";

export async function findOrderBicci(
  companies,
  initDateISO,
  endDateISO,
  isAdmin,
  startOffsetDays = 0,
  endOffsetDays = 0
) {
  const res = [];
  const { init, end } = rangeWithOffset(
    initDateISO,
    endDateISO,
    startOffsetDays,
    endOffsetDays
  );

  const ordersRef = collection(db, process.env.REACT_APP_COL_USERS_ORDERS);

  try {
    if (isAdmin) {
      const qy = query(
        ordersRef,
        where("updatedAt", ">=", init),
        where("updatedAt", "<=", end)
      );
      const snap = await getDocs(qy);
      snap.docs.forEach((d) => res.push({ id: d.id, ...d.data() }));
      return res;
    }

    for (const c of companies || []) {
      const id = c && c.integrationServicesBicciID;
      if (!id) continue;

      if (id !== "falabella") {
        const qy = query(
          ordersRef,
          where("companyID", "==", id),
          where("updatedAt", ">=", init),
          where("updatedAt", "<=", end)
        );
        const snap = await getDocs(qy);
        snap.docs.forEach((d) => res.push({ id: d.id, ...d.data() }));
      } else {
        const origins = (OriginsCompanys && OriginsCompanys[id]) || [];
        for (const place of origins) {
          try {
            const qy = query(
              ordersRef,
              where("placeName", "==", place),
              where("updatedAt", ">=", init),
              where("updatedAt", "<=", end)
            );
            const snap = await getDocs(qy);
            snap.docs.forEach((d) => res.push({ id: d.id, ...d.data() }));
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
  } catch (e) {
    // silencio
  }
  return res;
}

export async function findOrderBicciPending(companies, isAdmin) {
  const res = [];
  const ordersRef = collection(db, process.env.REACT_APP_COL_USERS_ORDERS);

  try {
    if (isAdmin) {
      const qy = query(
        ordersRef,
        where("status", ">=", 0),
        where("status", "<", 8)
      );
      const snap = await getDocs(qy);
      snap.docs.forEach((d) => {
        const data = d.data();
        if (
          data?.lostDelivery !== true &&
          !cancellationStatesFalabbelaSelector.includes(data?.intState)
        ) {
          res.push({ id: d.id, ...data });
        }
      });
      return res;
    }

    for (const c of companies || []) {
      const id = c && c.integrationServicesBicciID;
      if (!id) continue;

      if (id !== "falabella") {
        try {
          const qy = query(
            ordersRef,
            where("companyID", "==", id),
            where("status", ">=", 0),
            where("status", "<", 8)
          );
          const snap = await getDocs(qy);
          snap.docs.forEach((d) => {
            const data = d.data();
            if (
              data?.lostDelivery !== true &&
              !cancellationStatesFalabbelaSelector.includes(data?.intState)
            ) {
              res.push({ id: d.id, ...data });
            }
          });
        } catch (e) {
          console.log(e);
        }
      } else {
        const origins = (OriginsCompanys && OriginsCompanys[id]) || [];
        for (const place of origins) {
          try {
            const qy = query(
              ordersRef,
              where("placeName", "==", place),
              where("status", ">=", 0),
              where("status", "<", 8)
            );
            const snap = await getDocs(qy);
            snap.docs.forEach((d) => {
              const data = d.data();
              if (
                data?.lostDelivery !== true &&
                !cancellationStatesFalabbelaSelector.includes(data?.intState)
              ) {
                res.push({ id: d.id, ...data });
              }
            });
          } catch (e) {
            console.error(e);
          }
        }
      }
    }
  } catch (e) {
    console.log("Error fetching pending orders:", e);
  }

  return res;
}

export function listenOrdersByUpdatedAt(initISO, endISO, cb) {
  const ordersRef = collection(db, process.env.REACT_APP_COL_USERS_ORDERS);
  const { init, end } = rangeFromIsoStrings(initISO, endISO);
  const qy = query(
    ordersRef,
    where("updatedAt", ">=", init),
    where("updatedAt", "<=", end)
  );
  const unsubscribe = onSnapshot(qy, (snapshot) => cb(snapshot.docChanges()));
  return unsubscribe;
}
